import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* searchTileSagas() {
  yield mapSagasFromConfigurations('searchTile')(configurations)
}

export default searchTileSagas;



// WEBPACK FOOTER //
// ./src/state/modules/search-tile/sagas.js